import { axiosPulmonology } from "../../../../api/axios";
import { PULMONOLOGY_PATHS } from "../../../../api/endpoints";

export const PULMONOLOGY_RESOURCES = [
  "reason-symptoms",
  "physical-examination",
  "suspected-diagnoses",
  "imaging",
  "pulmonary-function-tests",
  "bronchoscopy",
  "specific-biology",
  "conclusion-plan",
  "allergy-workup",
];

export const listPulmonologyRecords = async (patientId, resource) => {
  const { data } = await axiosPulmonology.get(
    PULMONOLOGY_PATHS.BY_PATIENT(patientId, resource)
  );
  return Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
};

export const createPulmonologyRecord = async ({ patientId, resource, payload, documentId }) => {
  const { data } = await axiosPulmonology.post(
    PULMONOLOGY_PATHS.BY_PATIENT(patientId, resource),
    payload,
    documentId ? { headers: { "x-document-id": documentId } } : undefined
  );
  return data;
};

export const updatePulmonologyRecord = async ({ resource, id, payload }) => {
  const { data } = await axiosPulmonology.patch(
    PULMONOLOGY_PATHS.BY_ID(resource, id),
    payload
  );
  return data;
};

export const deletePulmonologyRecord = async ({ resource, id }) => {
  const { data } = await axiosPulmonology.delete(
    PULMONOLOGY_PATHS.BY_ID(resource, id)
  );
  return data;
};